module.exports = __webpack_public_path__ + "img/Note.33b46f5a.png";